// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Mxf2V","title":"Header_title__HeGUC","left":"Header_left__6djy3","clinicName":"Header_clinicName__2-XUc"};